
<style scoped>
    .Field {
        padding: 0.25rem;
    }

    /* .Field label {
                                                    margin-bottom: 0.5rem;
                                                } */

    .Field input {
        width: 50%;
        margin-top: 0.5rem;
        padding-top: 4px;
        padding-right: 8px;
        padding-bottom: 4px;
        padding-left: 8px;
        border-style: solid;
        border-radius: unset;
        border-color: rgb(37, 42, 43);
    }

    .Field input:focus {
        border-radius: unset;
    }
</style>


<template lang="pug">

.ShortText.flex.col

    .Field.flex.col
        //- label( :for="id+0" ) {{ data.label }}
        //- input( :type="data.type" :name="data.name" :id="id+0" :placeholder="data.placeholder" @input="OnInput" :required="data.required||false" )

        //- label
            |{{ data.label }}
            br
            input( :type="data.type" :name="data.name" :id="data.id" :placeholder="data.placeholder" @input="OnInput" :required="data.required||false" )
        
        label.flex.col
            span {{ data.label }}
            input( :type="data.type" :name="data.name" :id="data.id" :placeholder="data.placeholder" v-model="inputs[index]" :required="data.required||false" )

</template>


<script>

import { defineComponent, ref, reactive, } from 'vue'

import useState from '../state'

export default defineComponent( {

    name: 'ShortText',

    props: ['index', 'data', /*'type', 'name', 'label', 'placeholder'*/],

    setup( props ) {

        const id = ref( `e-${ props.index }-` )

        const { form, inputs } = useState()

        // const OnInput = ev => {

        //     const index = props.index - 1
        //     const value = ev.target.value

        //     console.log( 'OnChange > index:', index )
        //     console.log( 'OnChange > id:', id.value )
        //     console.log( 'OnChange > ev:', ev )
        //     console.log( 'OnChange > value:', value )

        //     form.data[index] = {
        //         value: value,
        //     }

        // }

        return {
            id, inputs,
        }

    },

} )
</script>